import { Transition } from "motion";

function documentViewPanelSettings() {
    // ===== animations (only used when min1100) =====
    const chatVariants = {
        full: { width: "100%" },
        shrunk: { width: "50%" }
    };

    const panelVariants = {
        closed: { width: 0, opacity: 0, x: 40 },
        open: { width: "50%", opacity: 1, x: 0 }
    };

    const spring: Transition = { type: "spring", stiffness: 260, damping: 28 };

    return { chatVariants, panelVariants, spring };
}

export default documentViewPanelSettings;
